import {Observable} from 'rxjs';
import {Contact, Ref} from '@lifeislife/lifeislife-domain';


export abstract class WebPushRegistrationService {

  public abstract subscribeToNotifications$(contactRef: Ref<Contact>): Observable<any>;

  /**
   * Can create a new subscription (triggering the browser popup)
   */
  public abstract canSubscribe$(): Observable<boolean>;

  /**
   * Does a subscription exists for this device already.
   */
  public abstract hasSubscribe$(): Observable<boolean>;

  public abstract canSubscribe(): boolean;

  public abstract discard(): void;

}
